import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import * as types from './types';

export const invoiceProjectMutations = {
  [types.Invoice_Projects.SET.ALL](state, payload) {
    state.invoiceProjects = payload;
  },
  [types.Invoice_Project_Details.SET.SINGLE](state, payload) {
    state.invoiceProjectDetails = payload;
  },
  [types.SET_B2B_TEXT_ELEMENTS](state, payload) {
    console.log('payload2',payload)
    state.invoiceProjectDetails.invoice_project['text_elements'] = payload;
  },
  [types.Invoice_Project_Details.UPDATE.SINGLE](state, payload) {
    const { name, value } = payload;
    state.invoiceProjectDetails.invoice_project[name] = value;
  },
  ...implementSetAllNavTabDetailsMutation(types.InvoiceProjectDetails, 'invoiceProjectDetails'),
}